import { CircularProgress, styled } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { intl } from '../../../../../i18n'
import { colorPalette } from '../../../../style/colorPalette'

type InteractiveProps = {
  versionName: string
  threadCount?: number
  isExpanded: boolean
  isLoading: boolean
  onToggle: () => void
}

export const InteractiveVersionSeparator = ({
  versionName,
  threadCount,
  isExpanded,
  isLoading,
  onToggle,
}: InteractiveProps) => (
  <InteractiveContainer
    onClick={onToggle}
    role="button"
    aria-expanded={isExpanded}
  >
    <Icon>
      {isLoading ? (
        <CircularProgress size={14} />
      ) : isExpanded ? (
        <ExpandMoreIcon fontSize="small" />
      ) : (
        <ChevronRightIcon fontSize="small" />
      )}
    </Icon>
    <Label>{versionName}</Label>
    {typeof threadCount === 'number' && (
      <ThreadCountBadge count={threadCount} />
    )}
    <Line />
  </InteractiveContainer>
)

export const StaticVersionSeparator = ({
  versionName,
  threadCount,
}: {
  versionName: string
  threadCount?: number
}) => (
  <StaticContainer>
    <Label>{versionName}</Label>
    {typeof threadCount === 'number' && (
      <ThreadCountBadge count={threadCount} />
    )}
    <Line />
  </StaticContainer>
)

const ThreadCountBadge = ({ count }: { count: number }) => (
  <CountText>
    {intl.formatMessage({ id: 'discussion.threadCount' }, { n: count })}
  </CountText>
)

const InteractiveContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '8px 0',
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    color: colorPalette.skyBlue[7],
  },
})

const StaticContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '8px 0',
})

const Icon = styled('span')({
  display: 'flex',
  alignItems: 'center',
  color: colorPalette.monotone[5],
})

const Label = styled('span')({
  fontSize: '12px',
  fontWeight: 600,
  color: colorPalette.monotone[7],
  whiteSpace: 'nowrap',
})

const Line = styled('span')({
  flex: 1,
  height: '1px',
  backgroundColor: colorPalette.monotone[2],
})

const CountText = styled('span')({
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: 1,
  color: colorPalette.monotone[5],
})
